import { render, staticRenderFns } from "./detailSKU.vue?vue&type=template&id=93ccf4ea&scoped=true&"
import script from "./detailSKU.vue?vue&type=script&lang=js&"
export * from "./detailSKU.vue?vue&type=script&lang=js&"
import style0 from "./detailSKU.vue?vue&type=style&index=0&id=93ccf4ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ccf4ea",
  null
  
)

export default component.exports